import React, { useState } from "react";
import {
  Button,
  Confirm,
  showNotification,
  withDataProvider,
} from "react-admin";
import { connect } from "react-redux";

function UpdateStatusIssuedTicketButton(props) {
  const [isOpen, setOpen] = useState(false);
  const {
    dataProvider,
    resource,
    showNotification,
    selectedTickets = [],
    isLoadingTickets = false,
    label,
    icon,
  } = props;

  const travelIds = selectedTickets.map((tk) => tk.travelID).filter(Boolean);

  const handleDialogClose = () => setOpen(false);

  const handleConfirm = () => {
    dataProvider(
      "STATUS_ISSUED_TRAVELS",
      "",
      { status: "issued", travelIDs: travelIds },
      {
        onSuccess: {
          notification: {
            body: "Le Statut des voyages a été changé en émis.",
            level: "info",
          },
          refresh: true,
          redirectTo: `/${resource}`,
          unselectAll: true,
        },
      }
    ).catch((error) => {
      showNotification(
        `Erreur lors du rafraichissement ${error.message}`,
        "warning"
      );
    });
    setOpen(false);
  };

  return (
    <>
      <Button
        label={isLoadingTickets ? "Patientez..." : label}
        disabled={isLoadingTickets}
        onClick={() => setOpen(true)}
      >
        {icon}
      </Button>
      <Confirm
        isOpen={isOpen}
        title="Changer le statut des voyages en émis"
        content="Voulez-vous mettre le statut en émis ?"
        onConfirm={handleConfirm}
        onClose={handleDialogClose}
      />
    </>
  );
}

export default connect(null, {
  showNotification,
})(withDataProvider(UpdateStatusIssuedTicketButton));
